export enum ExceptionTypes {
  UserError = "UserError",
  ShopifyUserAlreadyExists = "ShopifyUserAlreadyExists",
}

export enum MsalExceptionTypes {
  InteractionRequired = "interaction_required",
}
